import './Login.scss';

import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import LoginForm from '@/common/components/organisms/LoginForm/LoginForm';
import { ROUTE_REGISTER } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import { useConfig } from '@/common/contexts/ConfigContext';
import RecaptchaContextProvider from '@/common/contexts/RecaptchaContext';
import withLoginLogic from '@/common/hoc/withLoginLogic';
import LoginTemplate from '@/ebat/components/blocks/Login/Login.template';
import ForgotPassword from '@/ebat/components/blocks/Modal/Common/ForgotPassword/ForgotPassword';
import useLogin from '@/ebat/components/pages/Login/useLogin';
import { ReactComponent as ErrorIcon } from '@/materiaux/assets/icons/warning.svg';

import { LoginDefaultProps, LoginPropTypes } from './Login.proptypes';

const Login = ({ paramIsOpen, onSubmit, errors }) => {
  const { t } = useTranslation();
  const { isEbat, env } = useConfig();
  const { isAPIDown } = useAuth();
  const { openModal, closeModal, handlePushDataLayer } = useLogin();

  return (
    <>
      <Helmet>
        <title>
          {t('common:entities:login.title')} - {t(`${env}:messages:title`)}
        </title>
      </Helmet>
      <LoginTemplate className="login">
        {isAPIDown && (
          <div className="page-login__api-down">
            <p className="message">{t('common:messages:api.down')}</p>
          </div>
        )}
        <RecaptchaContextProvider>
          <LoginForm
            className="page-login__form"
            errors={errors}
            errorsIcon={<ErrorIcon />}
            onForgotPassword={openModal}
            onSubmit={onSubmit}
            onSuccess={handlePushDataLayer}
            registerLink={isEbat ? ROUTE_REGISTER : null}
            title={t('ebat:entities:login.connect.title')}
          />
        </RecaptchaContextProvider>
      </LoginTemplate>
      <ForgotPassword closeModal={closeModal} isOpen={paramIsOpen} />
    </>
  );
};

Login.defaultProps = {
  ...LoginDefaultProps,
};

Login.propTypes = {
  ...LoginPropTypes,
};

export default withLoginLogic(Login);
